export default "  <pagesnavbar-cmp></pagesnavbar-cmp>\r\n  <router-outlet></router-outlet>\r\n"